<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppCabecalho from '@/components/AppCabecalho'
import ListagemGenerica from '@/components(new)/UI/Tables/ListagemGenerica/ListagemGenerica.vue'
import RegistrationTypeModal from '@/components(new)/UI/Modals/RegistrationType/RegistrationType.vue'
import FiltroGenerico from '@/components(new)/UI/Filters/FiltroGenerico/FiltroGenerico.vue'
import TitlePage from '@/components(new)/UI/Typography/TitlePage/TitlePage.vue'
import BaseTable from '@/components(new)/UI/Tables/BaseTable/BaseTable.vue'
import CustomButton from '@/components(new)/UI/Buttons/CustomButton/CustomButton.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import moment from 'moment'
import EMPTY_FILTRO_CADASTRO from '@/libs/models/filtro/emptyFiltroCadastroCentral'

export default {
  mixins: [
    AppNotificacao
  ],
  components: {
    AppCabecalho,
    ListagemGenerica,
    RegistrationTypeModal,
    FiltroGenerico,
    TitlePage,
    BaseTable,
    CustomButton,
    InputSelect
  },
  data () {
    return {
      filtro: EMPTY_FILTRO_CADASTRO('CAIXA_ENTRADA'),
      totalElements: 0,
      totalPages: 0,
      cadastros: [],
      modalVisible: false,
      municipios: []
    }
  },
  mounted () {
    this.loadLista()
    this.getMunicipios()
  },
  methods: {
    ...mapActions({
      getCadastros: 'listagem/getItems',
      count: 'listagem/count',
      delete: 'listagem/delete',
      getUsuario: 'auth/getUsuario',
      findMunicipioByCadastros: 'municipios/findMunicipioByCadastros'
    }),
    async loadLista () {
      const response = await this.getCadastros(this.filtro)
      this.cadastros = this.formatarDadosTabela(response.content)
      this.totalElements = response.totalElements
      this.totalPages = response.totalPages
    },
    formatarDadosTabela (dados) {
      return dados.map(dado => ({
        ...dado,
        data: dado ? moment(dado.data).format('DD/MM/YYYY HH:mm:ss') : '-',
        actions: [
          { key: 'edit', label: 'Editar cadastro', icon: 'pencil-alt', action: this.editarCadastro },
          { key: 'delete', label: 'Remover cadastro', icon: 'times', action: this.remove }
        ]
      }))
    },
    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.loadLista()
    },
    pesquisar (pesquisaSimples) {
      this.filtro.campoSimples = pesquisaSimples
      this.filtro.pagina = 0
      this.loadLista()
    },
    limparPesquisa () {
      this.filtro = EMPTY_FILTRO_CADASTRO('CAIXA_ENTRADA')
      this.loadLista()
    },
    async getPerfil () {
      const usuario = await this.getUsuario()
      switch (usuario.perfilSelecionado.codigo) {
        case 'CADASTRANTE_TECNICO':
          return 'TECNICO'
        default:
          return 'AGRICULTOR'
      }
    },
    async novoCadastro () {
      const usuario = await this.getUsuario()
      if (usuario.perfilSelecionado.codigo === 'CADASTRANTE_EMPRESARIAL') {
        this.modalVisible = true
      } else {
        this.$router.push({
          name: 'praticas/new',
          params: {
            idCadastro: 'new',
            tipoCadastro: await this.getPerfil()
          }
        })
      }
    },
    async getMunicipios () {
      const municipios = await this.findMunicipioByCadastros()
      this.municipios = municipios.map(municipio => { return {id: municipio.id, nome: municipio.nome} })
    },
    handleRegistrationSelected (tipoCadastro) {
      this.$router.push({
        name: 'praticas/new',
        params: {
          idCadastro: 'new',
          tipoCadastro: tipoCadastro
        }
      })
      this.modalVisible = false
    },
    editarCadastro (dadosTabela) {
      this.$router.push({
        name: dadosTabela.modalidadeCadastro === 'EMPRESA' ? 'formulario-imovel' : 'formulario-proprietario',
        params: {idCadastro: dadosTabela.id, tipoCadastro: dadosTabela.modalidadeCadastro}
      })
    },
    async remove (dadosTabela) {
      this.confirmBox(`Depois de removido, não será possível recuperar este cadastro.
      Tem certeza que deseja remover este cadastro?`,
      this.$messages.TITULO_WARNING,
      async () => {
        await this.delete(dadosTabela.id)
        this.changePage(1)
      },
      () => {
      }, 'Confimar', 'Cancelar')
    },
    closeModal () {
      this.modalVisible = false
    }
  }
}
</script>

<template>
  <div class="container praticas-sustentaveis">
    <div class="content-cadastro">
      <TitlePage
        title="Bem-vindo(a) ao Plano ABC+ PA"
        subTitle="Cadastre práticas sustentáveis aqui!"
      />
      <el-row>
        <el-col :span="20">
          <FiltroGenerico
            placeholder="Pesquisar por número do protocolo ou nome do proprietário..."
            @filtrosPesquisa="pesquisar"
            @limpar="limparPesquisa"
          >
            <template #filtros>
              <InputSelect
                label="Municípios:" v-model="filtro.municipios"
                :multiSelect="true"
                :opcoes="municipios"
              />
            </template>
          </FiltroGenerico>
        </el-col>
        <el-col :span="4" style="display: flex; justify-content: flex-end;">
          <CustomButton icon="el-icon-plus" text="Novo cadastro" @click="novoCadastro" />
        </el-col>
      </el-row>
      <BaseTable
        title="Listagem"
        :tableData="cadastros"
        emptyText="Não foram encontrados cadastros."
        :columns="[
          { key: 'protocolo', label: 'N° Cadastro' },
          { key: 'proprietarioNomeRazaoSocial', label: 'Proprietário' },
          { key: 'tipoCadastro', label: 'Tipo de cadastro' },
          { key: 'municipio', label: 'Município' },
          { key: 'data', label: 'Última atualização' },
          { key: 'actions', label: 'Ações' }
        ]"
        :pagination="{
          show: true,
          pageSize: filtro.tamanhoPagina,
          totalPages: totalPages,
          totalElements: totalElements
        }"
        @pageChange="changePage"
      />
    </div>
    <RegistrationTypeModal
      :visible.sync="modalVisible"
      :closeOnClickOutside="true"
      @onRegistrationSelected="handleRegistrationSelected"
      @closeModal="closeModal"
      title="Selecione qual o tipo de cadastro:"
      :options="[
        {
          key: 'EMPRESA',
          label: 'Empresa'
        }, {
          key: 'PARCEIROS_FORNECEDORES',
          label: 'Parceiros/Fornecedores'
        }
      ]"
    />
  </div>
</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/listagem-cadastros/listagem-cadastros.vue